import { Component, OnInit, AfterViewInit, ElementRef, Input } from '@angular/core';
import { getCurrentLanguage } from '../core/helpers/utils';
import { logTranslations } from './translations-log';
import { generalTranslations } from '../core/helpers/translations';
import { ActivatedRoute } from '@angular/router';
import { formatDateString, formatDateStringWithTime } from '../core/helpers/utils';

// services
import { EventService } from 'src/app/core/service/event.service';
import { LogService } from './log.service';

// constants
import { EventType } from 'src/app/core/constants/events';

// types
import { SortEvent } from 'src/app/shared/advanced-table/sortable.directive';
import { Column } from 'src/app/shared/advanced-table/advanced-table.component';
import { Log } from './log.model';


import { Router } from '@angular/router';

@Component({
  selector: 'app-list-log',
  templateUrl: './list-log.component.html',
  styleUrls: ['./list-log.component.scss']
})
export class ListLogComponent implements OnInit {

  @Input() tipo: string = '';  // Se añade el parámetro de entrada tipo

  constructor(
    private eventService: EventService,
    private route: ActivatedRoute,
    private router: Router,
    private elRef: ElementRef,
    private logService: LogService) { }

  records: Log[] = [];
  columns: Column[] = [];
  pageSizeOptions: number[] = [10, 25, 50, 100];

  // Botón de acción de la tabla
  buttonTitle: string = '';
  buttonLink: string = '';

  // Control de loading de la tabla cuando los usuarios hayan sido recibidos desde el backend
  loaded: boolean = false;

  // Control de errores
  error: string = '';

  // Para controlar las búsquedas
  allDatasearch: Log[] = []

  ngAfterViewInit(): void {

  }


  ngOnInit(): void {
    let currentLanguage: string = getCurrentLanguage()
    const currentTranslations = generalTranslations[currentLanguage].TABLE;

    this._fetchData(); // Llamamos al fetchData dependiendo del tipo
  }

  /**
   * Fetches table records based on 'tipo'
   */
  _fetchData(): void {
    const id_expediente = this.route.snapshot.paramMap.get('id');
    // Condición para verificar el tipo
    if (this.tipo === 'expediente' && id_expediente) {
      // Llamada a getLogExpediente si tipo es "expediente"
      this.logService.getLogExpediente(id_expediente).subscribe({
        next: (resLog) => {
          this.records = resLog;
          this.allDatasearch = this.records;
          this.initTableCofig(); // Inicializa las columnas de la tabla
          this.loaded = true;
        },
        error: (error: string) => {
          this.error = error;
          this.loaded = false;
        }
      });
    } else if (this.tipo === 'completo') {
      // Llamada a getLogCompleto si tipo es "completo"
      this.logService.getLogCompleto().subscribe({
        next: (resLog) => {
          //console.log("resLog",resLog)
          this.records = resLog;
          this.allDatasearch = this.records;
          this.initTableCofig(); // Inicializa las columnas de la tabla
          this.loaded = true;
        },
        error: (error: string) => {
          this.error = error;
          this.loaded = false;
        }
      });
    }
  }

  /**
   * Initialize advanced table columns
   */
  initTableCofig(): void {
    let currentLanguage: string = getCurrentLanguage();
    const currentTranslations = logTranslations[currentLanguage].TABLE;

    // Configuración de las columnas dependiendo del valor de "tipo"
    this.columns = [
      {
        name: 'fecha',
        label: currentTranslations.DATE,
        formatter: (record: Log) => record.fecha ? formatDateStringWithTime(record.fecha, currentLanguage) : '',
        width: 60
      },
    ];

    if (this.tipo === 'completo') {
      // Si es "completo", añadimos la columna del id_expediente
      this.columns.push({
        name: 'numero_expediente',
        label: currentTranslations.CASO,  // Puedes agregar traducción aquí si es necesario
        formatter: (record: Log) => record.numero_expediente || '',  // Mostrar id_expediente si existe
        sort: true,
        width: 80
      });
    }

    // Añadimos las columnas restantes (nombre y detalles) en ambos casos
    this.columns.push(
      {
        name: 'nombre',
        label: currentTranslations.NAME,
        formatter: (record: Log) => record.nombre_usuario + ' ' + record.apellidos_usuario,
        sort: false,
        width: 80,
      },
      {
        name: 'detalles',
        label: currentTranslations.DETAILS,
        formatter: (record: Log) => this.formatDetalles(record),
        sort: false,
        width: 600,
      }
    );

    // Ordenar registros por fecha descendente al inicializar la tabla
    this.records = this.records.sort((a, b) => {
      const dateA = a.fecha ? new Date(a.fecha).getTime() : 0;
      const dateB = b.fecha ? new Date(b.fecha).getTime() : 0;
      return dateB - dateA; // Orden descendente
    });
  }


  // compares two cell values
  compare(v1: string | number, v2: string | number): any {
    return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
  }

  /**
   * Sort the table data
   * @param event column name, sort direction
   */
  onSort(event: SortEvent): void {
    if (event.direction === '') {
      this.records = this.allDatasearch;
    } else {
      this.records = [...this.records].sort((a, b) => {
        const res = this.compare(a[event.column] as string | number, b[event.column] as string | number);
        return event.direction === 'asc' ? res : -res;
      });
    }
  }

  /**
  * Recibe un texto y lo normaliza a lowercase y quita tildes para poder hacer búsquuedas
  * @param text Texto a normalizar
  */
  normalizeText(text: string): string {

    return text.trim().toLocaleLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Normaliza letras con tilde
  }


  /**
   * Match table data with search input
   * @param row Table row
   * @param term Search the value
   */
  matches(row: Log, term: string): boolean {
    const normalizedTerm = this.normalizeText(term);

    // 1. Buscar en la columna 'fecha'
    const formattedDate = row.fecha ? formatDateString(row.fecha, getCurrentLanguage()) : '';
    const dateMatch = this.normalizeText(formattedDate).includes(normalizedTerm);

    // 2. Buscar en la columna 'nombre'
    const fullName = `${row.nombre_usuario} ${row.apellidos_usuario}`;
    const nameMatch = this.normalizeText(fullName).includes(normalizedTerm);

    // 3. Buscar en la columna 'detalles'
    const detallesMatch = this.normalizeText(this.formatDetalles(row)).includes(normalizedTerm);

    // Retornar true si se encuentra el término en cualquiera de las columnas
    return dateMatch || nameMatch || detallesMatch;
  }



  /**
   * Search Method
  */
  searchData(searchTerm: string): void {
    if (searchTerm === '') {
      this.records = this.allDatasearch;
    }
    else {
      let updatedData = this.allDatasearch;

      //  filter
      updatedData = updatedData.filter(record => this.matches(record, searchTerm));
      //console.log("updatedData ->",updatedData)
      this.records = updatedData;
    }

  }

  /**
  * Format the 'detalles' field based on the 'concepto' value
  * @param record Log record
  * @returns Formatted string for 'detalles'
  */
  formatDetalles(record: Log): string {
    const detalles = record.detalles;
    if (typeof detalles !== 'object') {
      return '';
    }

    const currentLanguage: string = getCurrentLanguage(); // Obtener el idioma actual

    switch (record.concepto) {
      case 'LOGIN':
        return '<b>LOGIN</b>'
      case 'EXPEDIENTE_CREAR':
        return '<b>EXPEDIENTE CREADO</b>'
      case 'EXPEDIENTE_DESCARGAR_ZIP':
        return `<b>${record.concepto.replace('_', ' ').toUpperCase()}</b> realizado`;
      case 'EXPEDIENTE_MODIFICAR':
        let cambios = Object.entries(detalles)
          .map(([campo, valor]: [string, any]) => {
            if (valor && typeof valor === 'object' && 'anterior' in valor && 'nuevo' in valor) {
              const fieldName = this.getReadableFieldName(campo);

              // Verificar si los valores son fechas y formatearlas
              let anterior = this.isDate(valor.anterior) ? formatDateString(valor.anterior, currentLanguage) : valor.anterior;
              let nuevo = this.isDate(valor.nuevo) ? formatDateString(valor.nuevo, currentLanguage) : valor.nuevo;

              // Si es un campo numérico, formatear como moneda
              if (campo.startsWith('demanda_') || campo.startsWith('reconvencion_') || campo.startsWith('cuantia_')) {
                anterior = this.formatCurrency(anterior);
                nuevo = this.formatCurrency(nuevo);
              }

              return `${fieldName}: de '${anterior}' a '${nuevo}'`;
            }
            return '';
          })
          .filter(entry => entry !== '')
          .join('<br>'); // Usar <br> para saltos de línea en HTML
        return `<b>CASO MODIFICADO:</b><br>${cambios}`;

      case 'EXPEDIENTE_CAMBIO_ESTADO':
        if ('anterior' in detalles && 'nuevo' in detalles) {
          return `<b>ESTADO CAMBIADO</b> de '${detalles['anterior']}' a '${detalles['nuevo']}'`;
        }
        return '';

      case 'CARPETA_NUEVA':
        if ('ruta' in detalles && 'nombre' in detalles && 'tipo' in detalles) {
          return `<b>NUEVA CARPETA CREADA</b>: ${detalles['nombre']}<br>en ruta '${detalles['ruta']}' con tipo '${detalles['tipo']}'`;
        }
        return '';

      case 'CARPETA_RENOMBRAR':
        if ('ruta' in detalles && 'nombre_anterior' in detalles && 'nombre_nuevo' in detalles) {
          return `<b>CARPETA RENOMBRADA</b>: de '${detalles['nombre_anterior']}' a '${detalles['nombre_nuevo']}'<br>en ruta '${detalles['ruta']}'`;
        }
        return '';

      case 'CARPETA_BORRAR':
        if ('ruta' in detalles && 'nombre' in detalles && 'tipo' in detalles) {
          return `<b>CARPETA BORRADA</b>: ${detalles['nombre']}<br>en ruta '${detalles['ruta']}' con tipo '${detalles['tipo']}'`;
        }
        return '';

      case 'CARPETA_CAMBIAR_TIPO':
        if ('ruta' in detalles && 'tipo_anterior' in detalles && 'tipo_nuevo' in detalles) {
          return `<b>TIPO DE CARPETA CAMBIADO</b>: de '${detalles['tipo_anterior']}' a '${detalles['tipo_nuevo']}'<br>en ruta '${detalles['ruta']}'`;
        }
        return '';

      case 'CARPETA_SUBIR_ARCHIVO':
        if ('ruta' in detalles && 'nombre' in detalles) {
          return `<b>ARCHIVO SUBIDO</b>: ${detalles['nombre']}<br>en ruta '${detalles['ruta']}'`;
        }
        return '';

      case 'ARCHIVO_LECTURA':
        if ('ruta' in detalles && 'nombre' in detalles) {
          return `<b>ARCHIVO LEÍDO</b>: ${detalles['nombre']}<br>en ruta '${detalles['ruta']}'`;
        }
        return '';

      case 'ARCHIVO_BORRAR':
        if ('ruta' in detalles && 'nombre' in detalles) {
          return `<b>ARCHIVO BORRADO</b>: ${detalles['nombre']}<br>en ruta '${detalles['ruta']}'`;
        }
        return '';

      case 'ARCHIVO_RENOMBRAR':
        if ('ruta' in detalles && 'nombre_anterior' in detalles && 'nombre_nuevo' in detalles) {
          return `<b>ARCHIVO RENOMBRADO</b>: ${detalles['nombre_anterior']} -> ${detalles['nombre_nuevo']}<br>en ruta '${detalles['ruta']}'`;
        }
        return '';

      case 'ARCHIVO_MOVER':
        if ('nombre' in detalles) {
          return `<b>ARCHIVO MOVIDO</b>: ${detalles['nombre']}<br>Desde '${detalles['ruta_origen']}' a '${detalles['ruta_destino']}'`;
        }
        return '';

      case 'USUARIO_BORRAR':
        if ('nombre' in detalles && 'apellidos' in detalles && 'email' in detalles) {
          return `<b>USUARIO BORRADO</b>: ${detalles['nombre']} ${detalles['apellidos']} - ${detalles['email']}`;
        }
        return '';

      default:
        return '';
    }
  }

  /**
 * Checks if a value is a valid date string
 * @param value String to check
 * @returns Boolean indicating if the string is a date
 */
  isDate(value: any): boolean {
    if (typeof value !== 'string') {
      return false;
    }

    // Pattern to match common date formats (ISO and simple date format)
    const datePattern = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z)?$/;
    return datePattern.test(value) && !isNaN(Date.parse(value));
  }

  /**
 * Converts a field name to a more readable format.
 * @param fieldName The field name to convert.
 * @returns The human-readable string.
 */
  getReadableFieldName(fieldName: string): string {
    const fieldMappings: { [key: string]: string } = {
      numero_expediente: 'Número de expediente',
      fecha_solicitud: 'Fecha de solicitud',
      anomalias: 'Anomalías',
      anomalias_descripcion: 'Descripción de anomalías',
      estado: 'Estado',
      cuantia_demanda: 'Cuantía de la demanda',
      cuantia_reconvencion: 'Cuantía de la reconvención',
      tipo_tribunal: 'Tipo de tribunal',
      objeto_contrato: 'Objeto de la controversia',
      convenio_arbitral: 'Convenio arbitral',
      origen: 'Origen',
      sector: 'Sector',
      idioma: 'Idioma',
      sede: 'Sede',
      procedimiento: 'Procedimiento',
      tipo: 'Tipo',
      audiencias: 'Audiencias',
      rebeldia: 'Rebeldía',
      comentarios: 'Comentarios',
      incidencias: 'Incidencias',
      incidencias_otras: 'Otras incidencias',
      escrutinios_revision_comision: 'Escrutinios de revisión de comisión',
      incidencias_adicionales: 'Incidencias adicionales',
      impuesto_aplicable_general: 'Impuesto aplicable general',
      porcentaje_derecho_administracion_demanda: 'Porcentaje de derecho de administración demanda',
      porcentaje_honorario_arbitro_demanda: 'Porcentaje de honorario del árbitro demanda',
      porcentaje_derecho_administracion_reconvencion: 'Porcentaje de derecho de administración reconvención',
      porcentaje_honorario_arbitro_reconvencion: 'Porcentaje de honorario del árbitro reconvención',
      demanda_provision_admision: 'Demanda de provisión de admisión',
      demanda_provision_gasto_arbitro: 'Demanda de provisión de gasto del árbitro',
      demanda_provision_gasto_expediente: 'Demanda de provisión de gasto del expediente',
      demanda_provision_alquiler_sala: 'Demanda de provisión de alquiler de sala',
      reconvencion_provision_admision: 'Reconvención de provisión de admisión',
      reconvencion_provision_gasto_arbitro: 'Reconvención de provisión de gasto del árbitro',
      reconvencion_provision_gasto_expediente: 'Reconvención de provisión de gasto del expediente',
      reconvencion_provision_alquiler_sala: 'Reconvención de provisión de alquiler de sala',
    };
    return fieldMappings[fieldName] || fieldName.replace('_', ' ');
  }

  /**
   * Formats a value as a currency in euros.
   * @param value The value to format.
   * @returns The formatted string.
   */
  formatCurrency(value: number | string): string {
    const numberValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numberValue)) {
      return value.toString();
    }
    return numberValue.toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }



}
